<template>
  <div>
    <div class="bg">
      <div class="title">
        基本信息
      </div>
      <div class="mt10 flex" style="height: 70px">
        <!-- <el-image
          style="width: 70px; height: 70px"
          src="https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
          fit="fill"
          :preview-src-list="[
            'https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png'
          ]"
        ></el-image> -->
        <div class=" flex flex-column flex-between p10">
          <div class="goods-name">商品名称：{{ goodsInfo.wxshopSpuName }}</div>
          <div class="goods-up-date">上架时间：{{ goodsInfo.upStartTime }}</div>
        </div>
      </div>
    </div>
    <div class="bg">
      <el-radio-group
        v-model="searchCondition.radio4"
        size="small"
        class="mr20"
        @change="radio4Change"
      >
        <el-radio-button label="indicators">流量分析</el-radio-button>
        <el-radio-button label="act">销售分析</el-radio-button>
      </el-radio-group>
    </div>
    <template>
      <div class="bg" v-if="searchCondition.radio4 === 'indicators'">
        <div class="flex flex-between item-center mb20">
          <div class="title">
            近期趋势
          </div>
          <el-date-picker
            :clearable="false"
            v-model="searchCondition.applyDate1"
            type="daterange"
            align="right"
            start-placeholder="请选择时间段"
            end-placeholder="请选择时间段"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
            style="width:350px"
            :picker-options="pickerOptions1"
            @change="applyDate1Change"
          >
          </el-date-picker>
        </div>

        <div class="flex mb20">
          <div class="box flex flex-1">
            <div class="yuan">
              <span
                class="hmicon icon-a-shangpinxiangqingyexiaoguofenxi2x"
              ></span>
            </div>
            <div class="flex flex-1 flex-column flex-around">
              <div class="name">
                商品详情页效果分析
              </div>
              <div class="content">
                近{{
                  moment(this.searchCondition.applyDate1[1]).diff(
                    moment(this.searchCondition.applyDate1[0]),
                    "day"
                  ) + 1
                }}天平均流失率<i
                  class="el-icon-top success"
                  v-if="flowAnalysis.jumpLossProportion > 0"
                ></i>
                <i
                  class="el-icon-bottom danger"
                  v-if="flowAnalysis.jumpLossProportion < 0"
                ></i>
                {{ flowAnalysis.jumpLossProportion }}
                {{ flowAnalysis.jumpLossProportion || 0 }}%，较往期
                <i
                  class="el-icon-top success"
                  v-if="flowAnalysis.previousJumpLossProportion > 0"
                ></i>
                <i
                  class="el-icon-bottom danger"
                  v-if="flowAnalysis.previousJumpLossProportion < 0"
                ></i>

                {{ flowAnalysis.previousJumpLossProportion || 0 }}%
              </div>
            </div>
          </div>
          <div style="width:20px"></div>
          <div class="box flex flex-1">
            <div class="yuan">
              <span class="hmicon icon-a-shangpinxiangqingyeyouhua2x"></span>
            </div>
            <div class="flex flex-1 flex-column flex-around">
              <div class="name">
                商品详情页优化
              </div>
              <div class="content">
                优化商品的详情描述，突出卖点，追加高转化率活动类型的创建，提升销售
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <ve-line
            height="400px"
            :settings="chartLineSettings"
            :data="chartLineData"
            :extend="{ dataZoom }"
          ></ve-line>
        </div>
      </div>
      <template v-else>
        <div class="bg">
          <div class="flex flex-between item-center mb20">
            <div class="title">
              商品详情页效果
            </div>
            <el-date-picker
              :clearable="false"
              v-model="searchCondition.applyDate5"
              type="daterange"
              align="right"
              start-placeholder="请选择时间段"
              end-placeholder="请选择时间段"
              value-format="yyyy-MM-dd"
              size="small"
              class="mr10"
              style="width:350px"
              :picker-options="pickerOptions2"
              @change="applyDate5Change"
            >
            </el-date-picker>
          </div>
          <div class="flex mb20">
            <div class="box flex flex-1">
              <div class="yuan">
                <span class="hmicon icon-a-qushifenxi2x"></span>
              </div>
              <div class="flex flex-1 flex-column flex-around">
                <div class="name">
                  趋势分析
                </div>
                <div class="content">
                  近{{
                    moment(this.searchCondition.applyDate5[1]).diff(
                      moment(this.searchCondition.applyDate5[0]),
                      "day"
                    ) + 1
                  }}天共做了{{
                    saleAnalysis.activityNum || 0
                  }}次营销活动，比往期访客
                  <i
                    :class="
                      Number(saleAnalysis.previousVisitProportion) >= 0
                        ? 'el-icon-top success'
                        : 'el-icon-bottom danger'
                    "
                  ></i>

                  {{ saleAnalysis.previousVisitProportion || 0 }}%，成交客户
                  <i
                    :class="
                      Number(saleAnalysis.previousSaleMemberProportion) >= 0
                        ? 'el-icon-top success'
                        : 'el-icon-bottom danger'
                    "
                  ></i>
                  {{ saleAnalysis.previousSaleMemberProportion || 0 }}%，销售
                  <i
                    :class="
                      Number(saleAnalysis.previousSaleProportion) >= 0
                        ? 'el-icon-top success'
                        : 'el-icon-bottom danger'
                    "
                  ></i>
                  {{ saleAnalysis.previousSaleProportion || 0 }}%
                </div>
              </div>
            </div>
            <div style="width:20px"></div>
            <div class="box flex flex-1">
              <div class="yuan">
                <span class="hmicon icon-a-tishengxiaoshou2x"></span>
              </div>
              <div class="flex flex-1 flex-column flex-around">
                <div class="name">
                  提升销售
                </div>
                <div class="content">
                  优化商品的详细描述，突出卖点，追加高转化率活动类型的创建，提升销售
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <ve-line
              height="400px"
              :settings="chartLineSettings"
              :data="chartLineData"
              :extend="{ dataZoom }"
            ></ve-line>
          </div>
        </div>
      </template>
      <div class="bg">
        <div class="flex flex-between item-center mb20">
          <div class="title">
            SKU销售效果
          </div>
          <el-date-picker
            :clearable="false"
            v-model="searchCondition.applyDate2"
            type="daterange"
            align="right"
            start-placeholder="请选择时间段"
            end-placeholder="请选择时间段"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
            style="width:350px"
            :picker-options="pickerOptions2"
            @change="applyDate2Change"
          >
          </el-date-picker>
        </div>
        <div>
          <el-table
            stripe
            ref="table"
            :data="skuSalesList"
            style="width: 100%"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spec"
              label="规格"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="均价/售价(元)"
            >
              <template slot-scope="scope">
                ￥ {{ ToFixed(scope.row.avgPrice, 2) }} /
                <span class="primary">￥{{ ToFixed(scope.row.salePrice, 2) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="addCartPv"
              label="加购件数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="submitPv"
              label="下单件数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="submitUv"
              label="下单买家数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payPv"
              label="付款件数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payUv"
              label="付款买家数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payMoney"
              label="付款金额(元)"
            >
              <template slot-scope="scope">
                {{ ToFixed(scope.row.payMoney, 2) }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="submitPayProportion"
              label="下单-付款转化率"
            >
              <template slot-scope="scope">
                {{ scope.row.submitPayProportion }}%
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPage"
              :page-size="pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="bg">
        <div class="flex flex-between item-center mb20">
          <div class="title">
            复购分析
          </div>
          <div>
            <el-radio-group
              v-model="searchCondition.statisticsPeriod"
              @change="applyDate3Change"
            >
              <el-radio label="month">按月份</el-radio>
              <el-radio label="quarter">按季度</el-radio>
            </el-radio-group>
          </div>
          <!-- <el-date-picker
            :clearable="false"
            v-model="searchCondition.applyDate3"
            type="daterange"
            align="right"
            start-placeholder="请选择时间段"
            end-placeholder="请选择时间段"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
            style="width:350px"
            :picker-options="pickerOptions2"
            @change="applyDate3Change"
          >
          </el-date-picker> -->
        </div>
        <div class="flex mb20">
          <div class="box flex" style="width:50%">
            <div class="yuan">
              <span class="hmicon icon-a-fugoufenxi2x"></span>
            </div>
            <div class="flex flex-column flex-around">
              <div class="name">
                复购分析
              </div>
              <div class="content">
                近一年用户月/季度平均复购用率为{{ avgRepurchaseProportion }}%
              </div>
            </div>
          </div>
          <div style="width:20px"></div>
          <div class="box flex" style="opacity:0;width:50%">
            <div class="yuan">
              <span class="hmicon icon-a-fugoufenxi2x"></span>
            </div>
            <div class="flex flex-column flex-around">
              <div class="name">
                复购分析
              </div>
              <div class="content">
                近一年用户月/季度平均复购用率为{{ avgRepurchaseProportion }}%
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-table
            stripe
            ref="table"
            :data="afterPurchaseList"
            style="width: 100%"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="
                index =>
                  index + (currentPagePurchase - 1) * pageSizePurchase + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="timeQuantum"
              label="统计周期"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payUv"
              label="总付款人数"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payOneUv"
              label="购买一次"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payTwoUv"
              label="购买两次"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payThreeUv"
              label="购买三次"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payFourUv"
              label="购买四次"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="payFiveUv"
              label="购买五次及以上"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="repurchaseProportion"
              label="复购率"
            >
              <template slot-scope="scope">
                {{ scope.row.repurchaseProportion }}%
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalPurchase"
              @current-change="pagingPurchase"
              @size-change="handleSizeChangePurchase"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePurchase"
              :page-size="pageSizePurchase"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- <div class="bg">
      <div class="title">
        关联销售分析
      </div>
      <div class="flex item-center mt10 mb20">
        <div class="font-style mr10">适合</div>

        <div class="box flex item-center">
          <el-image
            style="width: 60px; height: 60px"
            src="https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
            fit="fill"
            :preview-src-list="[
              'https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png'
            ]"
          ></el-image>
          <div class="ml10 font-style" style="font-weight:500">
            惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐
          </div>
        </div>

        <div class="ml20 font-style">
          搭配销售组合的有：
        </div>
      </div>
      <div class="mt10">
        <el-carousel
          trigger="click"
          :interval="5000"
          arrow="hover"
          :autoplay="false"
          height="200px"
          indicator-position="outside"
        >
          <el-carousel-item v-for="(item, index) in carouselList" :key="index">
            <div class="flex flex-around">
              <div v-for="(k, i) in item" :key="i" class="flex-1 mr10">
                <div class="box flex flex-around  ">
                  <div v-for="(v, j) in k.goodsList" :key="j" class="">
                    <el-image
                      style="width: 60px; height: 60px"
                      :src="v.goodsimg"
                      fit="fill"
                      :preview-src-list="[
                        'https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png'
                      ]"
                    ></el-image>
                    <div class="carousel-goodsname text-overflow-2">
                      {{ v.goodsName }}
                    </div>
                  </div>
                </div>
                <div class="mt10" style="color:#999;font-size:13px">
                  <div class="text-center">
                    有 <span class="blue">321</span> 用户同时购买了以上商品
                  </div>
                  <div class="text-center">
                    快迎合消费者需求做好关联销售吧！
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div> -->

      <div class="bg">
        <div class="flex flex-between item-center mb20">
          <div class="title">
            商品流量来源和去向
          </div>
          <el-date-picker
            :clearable="false"
            v-model="searchCondition.applyDate4"
            type="daterange"
            align="right"
            start-placeholder="请选择时间段"
            end-placeholder="请选择时间段"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
            style="width:350px"
            :picker-options="pickerOptions2"
            @change="applyDate4Change"
          >
          </el-date-picker>
        </div>
        <div class="flex mb20">
          <div class="flex-1" style="width:50%">
            <div class="box flex ">
              <div class="yuan">
                <span
                  class="hmicon icon-a-shangpinliulianglaiyuanleixingfenxi2x"
                ></span>
              </div>
              <div class="flex flex-1  flex-column flex-around">
                <div class="name">
                  商品流量来源类型分析
                </div>
                <div class="content" v-if="trafficList.length">
                  {{ trafficList[0].pathName }}的流量来源占比最高，达到{{
                    trafficList[0].visitPvProportion
                  }}%
                  <!-- ，直接退出的流量去向占比最高，达到45.22% -->
                </div>
              </div>
            </div>
            <div class="mt20">
              <el-table
                stripe
                ref="table"
                :data="trafficList"
                style="width: 100%"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="pathName"
                  label="来源类型"
                >
                  <template slot-scope="scope" >
                    {{ scope.row.pathName ? scope.row.pathName : "其他" }}
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="visitPv"
                  label="访客数"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="ordewddwrSn"
                  label="访客数占比"
                >
                  <template slot-scope="scope">
                    <el-progress
                      :percentage="scope.row.visitPvProportion || 0"
                    ></el-progress>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- <div style="width:20px"></div> -->

          <!-- <div class="flex-1" style="width:50%">
            <div class="box flex ">
              <div class="yuan">
                <span class="hmicon icon-a-tishengxiaoshou2x"></span>
              </div>
              <div class="flex flex-1 flex-column flex-around">
                <div class="name">
                  优化分析
                </div>
                <div class="content">
                  店铺主页增加商品展示，利用好商品之间关联导购，定期进行广告投放，丰富商品的流量
                </div>
              </div>
            </div>
            <div class="mt20">
              <el-table
                stripe
                ref="table"
                :data="goToList"
                style="width: 100%"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="left"
                  prop="pathName"
                  label="来源类型"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="visitPv"
                  label="访客数"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="ordewddwrSn"
                  label="访客数占比"
                >
                  <template slot-scope="scope">
                    <el-progress
                      :percentage="scope.row.visitPvProportion || 0"
                    ></el-progress>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import VeLine from "v-charts/lib/line.common";
import moment from "moment";
import { ToFixed } from "@/utils/utils";
export default {
  components: {
    VeLine
  },
  data() {
    return {
      ToFixed,
      moment,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      totalPurchase: 0,
      currentPagePurchase: 1,
      pageSizePurchase: 10,
      searchCondition: {
        radio4: "indicators",
        applyDate1: [
          moment()
            .subtract("days", 7)
            .format("YYYY-MM-DD"),
          moment()
            .subtract("days", 1)
            .format("YYYY-MM-DD")
        ],
        applyDate2: [
          moment()
            .subtract("days", 7)
            .format("YYYY-MM-DD"),
          moment()
            .subtract("days", 1)
            .format("YYYY-MM-DD")
        ],
        // applyDate3: [
        //   moment()
        //     .subtract("days", 7)
        //     .format("YYYY-MM-DD"),
        //   moment()
        //     .subtract("days", 1)
        //     .format("YYYY-MM-DD")
        // ],
        statisticsPeriod: "month",
        applyDate4: [
          moment()
            .subtract("days", 7)
            .format("YYYY-MM-DD"),
          moment()
            .subtract("days", 1)
            .format("YYYY-MM-DD")
        ],
        applyDate5: [
          moment()
            .subtract("days", 7)
            .format("YYYY-MM-DD"),
          moment()
            .subtract("days", 1)
            .format("YYYY-MM-DD")
        ]
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
          // {
          //   text: "最近90天",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // }
        ]
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
          // {
          //   text: "最近90天",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // }
        ]
      },
      dataZoom: [
        {
          start: 0,
          type: "inside",
          show: true
        }
      ],
      chartLineSettings: {
        labelMap: {
          dateValue: "日期",
          new: "新客数",
          hh: "付款金额"
        }
      },
      chartLineData: {
        columns: [
          // "dateValue", "new", "hh"
        ],
        rows: [
          // { dateValue: "2019-1月1日", new: 123, hh: 99 },
          // { dateValue: "2019-2月1日", new: 1231, hh: 299 },
          // { dateValue: "2019-3月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-4月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-5月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-6月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-7月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-8月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-9月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-10月1日", new: 1123, hh: 399 },
          // { dateValue: "2019-11月1日", new: 1123, hh: 399 }
          // { 日期: "1月2日", 非分销订单: 1223, 分销订单: 123 },
          // { 日期: "1月3日", 非分销订单: 2123, 分销订单: 1223 },
          // { 日期: "1月4日", 非分销订单: 4123, 分销订单: 123 },
          // { 日期: "1月5日", 非分销订单: 3123, 分销订单: 123 },
          // { 日期: "1月6日", 非分销订单: 7123, 分销订单: 123 }
        ]
      },
      carouselList: [
        [
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          },
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          },
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          }
        ],
        [
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          },
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          },
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          }
        ],
        [
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          },
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          },
          {
            goodsList: [
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              },
              {
                goodsName: "惠氏三段新西兰进口羊奶粉适合0-3个月宝宝，800g/罐",
                goodsimg:
                  "https://imgcdn.hemiao100.com/ThemePictures/%E6%B5%81%E7%A8%8B%E5%9B%BE%402x.png"
              }
            ]
          }
        ]
      ],
      trafficList: [
        // {
        //   name: "直接访问"
        // },
        // {
        //   name: "主页"
        // },
        // {
        //   name: "微页面"
        // },
        // {
        //   name: "购物车"
        // },
        // {
        //   name: "订单详情页"
        // }
      ],
      goToList: [
        // {
        //   name: "直接退出"
        // },
        // {
        //   name: "主页"
        // },
        // {
        //   name: "微页面"
        // },
        // {
        //   name: "购物车"
        // }
      ],
      skuSalesList: [{}],
      afterPurchaseList: [{}],
      goodsInfo: {},
      saleAnalysis: {},
      flowAnalysis: {},
      avgRepurchaseProportion: 0
    };
  },
  created() {},
  mounted() {
    this.goodsInfo = JSON.parse(this.$route.query.goodsInfo);

    console.log("this.goodsInfo: ", this.goodsInfo);
    if (this.searchCondition.radio4 === "indicators") {
      this.queryFlowAnalysis();
    } else {
      this.querySaleAnalysis();
    }

    this.querySkuSaleAnalysis();
    this.queryRepurchaseAnalysis();
    this.querySpuToAnalysis();
    this.querySpuFromAnalysis();
  },
  methods: {
    radio4Change(val) {
      if (val === "indicators") {
        this.queryFlowAnalysis();
      } else {
        this.querySaleAnalysis();
      }
    },
    async querySaleAnalysis() {
      let params = {
        wxshopSpuId: this.goodsInfo.wxshopSpuId,
        startTime: this.searchCondition.applyDate5[0],
        endTime: this.searchCondition.applyDate5[1]
      };
      const { result } = await this.$store.dispatch(
        "querySaleAnalysis",
        params
      );
      this.chartLineData.columns = ["timeQuantum", "visitUv", "payMoney"];
      this.chartLineSettings.labelMap = {
        timeQuantum: "日期",
        visitUv: "访客数",
        payMoney: "付款金额"
      };
      this.chartLineData.rows = result.dataList;
      this.saleAnalysis = result;
    },
    async queryFlowAnalysis() {
      let params = {
        wxshopSpuId: this.goodsInfo.wxshopSpuId,
        startTime: this.searchCondition.applyDate1[0],
        endTime: this.searchCondition.applyDate1[1]
      };
      const { result } = await this.$store.dispatch(
        "queryFlowAnalysis",
        params
      );
      this.chartLineData.columns = [
        "timeQuantum",
        "visitUv",
        "visitTime",
        "jumpLossProportion"
      ];
      this.chartLineSettings.labelMap = {
        timeQuantum: "日期",
        visitUv: "访客数",
        visitTime: "页面平均停留时长",
        jumpLossProportion: "商品详情跳失率"
      };
      this.chartLineData.rows = result.dataList;
      this.flowAnalysis = result;
    },
    async querySkuSaleAnalysis() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        wxshopSpuId: this.goodsInfo.wxshopSpuId,
        startTime: this.searchCondition.applyDate2[0],
        endTime: this.searchCondition.applyDate2[1]
      };
      const { result } = await this.$store.dispatch(
        "querySkuSaleAnalysis",
        params
      );
      const { total, records } = result;
      this.skuSalesList = records;
      this.total = total;
    },
    async queryRepurchaseAnalysis() {
      let params = {
        pageSize: this.pageSizePurchase,
        pageNo: this.currentPagePurchase,
        wxshopSpuId: this.goodsInfo.wxshopSpuId,
        statisticsPeriod: this.searchCondition.statisticsPeriod
      };
      const { result } = await this.$store.dispatch(
        "queryRepurchaseAnalysis",
        params
      );
      const { avgRepurchaseProportion, page } = result;
      this.avgRepurchaseProportion = avgRepurchaseProportion;
      const { total, records } = page;
      this.afterPurchaseList = records;
      this.totalPurchase = total;
    },
    async querySpuToAnalysis() {
      let params = {
        wxshopSpuId: this.goodsInfo.wxshopSpuId,
        startTime: this.searchCondition.applyDate4[0],
        endTime: this.searchCondition.applyDate4[1]
      };
      const { result } = await this.$store.dispatch(
        "querySpuToAnalysis",
        params
      );
      this.goToList = result;
    },
    async querySpuFromAnalysis() {
      let params = {
        wxshopSpuId: this.goodsInfo.wxshopSpuId,
        startTime: this.searchCondition.applyDate4[0],
        endTime: this.searchCondition.applyDate4[1]
      };
      const { result } = await this.$store.dispatch(
        "querySpuFromAnalysis",
        params
      );

      result.sort((a, b) => b.visitPvProportion - a.visitPvProportion);
      result.forEach(v => {
        if (v.path == "-") {
          v.pathName = "直接访问";
        }
      });
      this.trafficList = result;
    },
    applyDate1Change(val) {
      console.log("val1: ", val);
      this.queryFlowAnalysis();
    },
    applyDate2Change(val) {
      console.log("val2: ", val);
      this.pageSize = 1;
      this.currentPage = 10;
      this.querySkuSaleAnalysis();

      // this.querySkuSaleAnalysis();
    },
    applyDate3Change(val) {
      console.log("val3: ", val);
      this.pageSizePurchase = 1;
      this.currentPagePurchase = 10;
      this.queryRepurchaseAnalysis();
    },
    applyDate4Change(val) {
      console.log("val4: ", val);
      // this.trafficList=[]
      // this.goToList=[]
      this.querySpuFromAnalysis();
    },
    applyDate5Change(val) {
      console.log("val5: ", val);
      this.querySaleAnalysis();
    },
    paging(page) {
      this.currentPage = page;
      this.querySkuSaleAnalysis();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.querySkuSaleAnalysis();
    },

    pagingPurchase(page) {
      this.currentPagePurchase = page;
      this.queryRepurchaseAnalysis();
    },
    handleSizeChangePurchase(size) {
      this.currentPagePurchase = 1;
      this.pageSizePurchase = size;
      this.queryRepurchaseAnalysis();
    }
  }
};
</script>

<style scoped lang="scss">
.bg {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 10px;
}
.font-style {
  font-weight: bold;
  font-size: 15px;
}
.title {
  color: #222222;
  font-weight: bold;
  font-size: 15px;
  font-weight: bold;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.goods-name {
  font-size: 16px;
  color: #222222;
  font-weight: 600;
}
.goods-up-date {
  color: #222222;
  font-size: 14px;
}
.box {
  box-shadow: 0px 0px 12px 0px rgba(221, 221, 221, 0.6);
  border-radius: 6px;
  padding: 20px;
  .yuan {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background: #feeef5;
    text-align: center;
    line-height: 66px;
    margin-right: 20px;
    .hmicon {
      color: #e50065;
      font-size: 30px;
    }
  }
  .name {
    color: #222222;
    font-size: 14px;
  }
  .content {
    font-weight: 600;
    color: #222222;
    font-size: 15px;
    // white-space: nowrap;
  }
}

.carousel-goodsname {
  width: 60px;
  font-size: 14px;
  margin-top: 10px;
}

.el-icon-top.el-icon-top {
  font-weight: bold;
}
</style>
